import { render, staticRenderFns } from "./CommunityUnitBusinessNews.vue?vue&type=template&id=2a3e51a5&scoped=true"
import script from "./CommunityUnitBusinessNews.vue?vue&type=script&lang=js"
export * from "./CommunityUnitBusinessNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3e51a5",
  null
  
)

export default component.exports